import { create } from "zustand";

// Type aligned with TRPC eventInputSchema
type EventFormValues = {
  title: string;
  description: string;
  imageUrl: string;
  allDay: boolean;
  start: string;
  end: string;
  calendarId: string;
};

export interface EventsModalState {
  isOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  defaultValues: Partial<EventFormValues>;
  setDefaultValues: (values: Partial<EventFormValues>) => void;
  eventId: string | null;
  setEventId: (id: string | null) => void;
}

export const useEventsModal = create<EventsModalState>((set) => ({
  isOpen: false,
  setIsModalOpen: (isOpen: boolean) => set(() => ({ isOpen })),
  defaultValues: {},
  setDefaultValues: (values: Partial<EventFormValues>) =>
    set(() => ({ defaultValues: values })),
  eventId: null,
  setEventId: (id: string | null) => set(() => ({ eventId: id })),
}));
